import { Injectable } from '@angular/core';
import { ApiInterface } from './api-interface';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { AtualizarSenhaResetDTO, ValidarCodigoResponseDTO } from '../models/auth/redefinicao-senha.model';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService implements ApiInterface {

  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<any> {
    throw new Error('Method not implemented.');
  }
  getById<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }
  post<T>(url: string, data: any): Observable<any> {
    return this.apiService.create(url, data);
  }
  put<T>(url: string, data: any): Observable<any> {
    return this.apiService.update(url, data);
  }
  delete<T>(url: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  // 1. Gera código de redefinição (PUT)
  gerarCodigoRedefinicaoSenha(email: string): Observable<any> {
    const body = { email };
    return this.put<any>('/usuario/gerarCodigoRedefinicaoSenha', body);
  }

  // 2. Valida código (POST) - backend retorna JSON { resetToken }
  validarCodigoRedefinicaoSenha(email: string, codigo: any): Observable<ValidarCodigoResponseDTO> {
    const codigoLimpo = String(codigo).replace(/[^0-9]/g, '');
    const codigoNumerico = parseInt(codigoLimpo, 10);
    const body = {
      email,
      codigoDeRedefinicaoSenha: codigoNumerico
    };
    return this.apiService.create<ValidarCodigoResponseDTO>('/usuario/validarCodigoDeRedefinicaoSenha', body);
  }

  // 3. Atualiza senha (PUT) - exige resetToken; backend retorna texto puro, não JSON
  atualizarSenha(email: string, novaSenha: string, resetToken: string): Observable<string> {
    const body: AtualizarSenhaResetDTO = {
      email,
      senha: novaSenha,
      resetToken
    };
    return this.apiService.updateText('/usuario/atualizarSenhaAposPedidoRedefinicao', body);
  }
}
